// import { locales } from './locales';

// const formatPrice = (cents) => {
//   if (typeof cents === 'string') {
//     cents = parseInt(cents.replace(/\D/g, ''), 10);
//   }

//   const totalPrice = (cents / 100.0).toFixed(2);
//   const country = window.Shopify.country || 'US';
//   const locale = locales[country];
//   const currency = window.Shopify.currency.active || 'USD';

//   const price = new Intl.NumberFormat(locale, {
//     style: 'currency',
//     currency,
//   }).format(totalPrice);

//   return price.replace('.00', '');
// };

function formatPrice(cents, variantId) {
  const { prices } = window.HMR;
  if (prices.get(variantId)) {
    return prices.get(variantId);
  }
  const totalPrice = (cents / 100.0).toFixed(2);
  // const country = window.Shopify.country || 'US';
  // const locale = locales[country];
  const currency = window.Shopify.currency.active || 'USD';
  // console.info('country', country, locale, currency, totalPrice);

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  }).format(totalPrice);
}

/**
 * Check if a formatted price string represents zero, regardless of currency
 * @param {string} formattedPrice - The formatted price string (e.g., "$0.00", "£0.00", "€0,00")
 * @returns {boolean} - True if the price is zero
 */
export function isPriceZero(formattedPrice) {
  if (!formattedPrice || formattedPrice.trim() === '') {
    // biome-ignore lint: debugging price display
    console.log('[isPriceZero] Empty or falsy price:', formattedPrice);
    return true;
  }

  // Remove all non-numeric characters except decimal points and commas
  // Handle multiple decimal separators by taking the first valid number
  const cleaned = formattedPrice.replace(/[^\d.,]/g, '');

  // Split by common separators and get the first number
  const numbers = cleaned.split(/[.,]/).filter((n) => n !== '');

  // If no numbers found, consider it zero
  if (numbers.length === 0) {
    // biome-ignore lint: debugging price display
    console.log('[isPriceZero] No numbers found in:', formattedPrice, 'cleaned:', cleaned);
    return true;
  }

  // Parse the first number (before decimal point)
  const integerPart = parseInt(numbers[0], 10) || 0;

  // If integer part is 0, check decimal part
  if (integerPart === 0 && numbers.length > 1) {
    const decimalPart = parseInt(numbers[1], 10) || 0;
    const result = decimalPart === 0;
    // biome-ignore lint: debugging price display
    console.log('[isPriceZero] Checking decimal:', {
      formattedPrice,
      cleaned,
      numbers,
      integerPart,
      decimalPart,
      result,
    });
    return result;
  }

  const result = integerPart === 0;
  // biome-ignore lint: debugging price display
  console.log('[isPriceZero] Checking integer:', {
    formattedPrice,
    cleaned,
    numbers,
    integerPart,
    result,
  });
  return result;
}

export default formatPrice;
